document.addEventListener('DOMContentLoaded', () => {
  const langs = document.querySelectorAll('.lang');
  langs?.forEach(lang => {
    lang.addEventListener('click', (evt) => {
      const target = evt.target.closest('div[data-iso]');
      if (target) {
        const newLocale = target.dataset.iso;
        const countryInput = lang.querySelector('input[name="country_code"]');
        
        // Special case for English - use GB as country code
        if (newLocale === 'en') {
          countryInput.value = 'GB';
        } else {
          countryInput.value = newLocale;
        }
        
        lang.querySelector('form').submit();
        return;
      }
      lang.classList.toggle('open');
      document.body.classList.toggle('blur');
    });
  })
});